exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-tableFooter-3aVAh{display:flex;justify-content:space-between;align-items:center;margin-top:16px;column-gap:8px}.style-cssmodule-results-3SpAb{color:var(--color-night-gray8,#32435e);font-size:14px;font-weight:400}.style-cssmodule-pagesButtonsContainer-1U9Hw,.style-cssmodule-pagination-ugVQ1{display:flex;align-items:center;column-gap:8px}.style-cssmodule-pagination-ugVQ1 [class*=MuiPaginationItem-page]{color:var(--color-night-gray8,#32435e)!important;font-size:14px!important;line-height:14px!important;cursor:pointer!important}.style-cssmodule-pagination-ugVQ1 [class*=MuiPaginationItem-page]:not(:has(svg)){min-width:22px!important;height:22px!important}.style-cssmodule-pagination-ugVQ1 .Mui-selected,.style-cssmodule-pagination-ugVQ1 [class*=MuiPaginationItem-page]:not(:has(svg)):hover{color:var(--color-blue-dark,#04249c)!important;background-color:var(--color-blue-lighter,#e7edf7)!important}", ""]);

// exports
exports.locals = {
	"tableFooter": "style-cssmodule-tableFooter-3aVAh",
	"results": "style-cssmodule-results-3SpAb",
	"pagesButtonsContainer": "style-cssmodule-pagesButtonsContainer-1U9Hw",
	"pagination": "style-cssmodule-pagination-ugVQ1"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/parkings/components/TableFooter/style.cssmodule.css
// module id = 2565
// module chunks = 121